<template>
    <b-navbar v-if="this.$store.getters.getIsLoggedIn" type="dark" toggleable="sm" variant="primary" class="mb-2">
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-navbar-nav class="mx-auto">
          <b-navbar-brand tag="h2" class="pb-0">{{this.$store.getters.getPropertyConfigurationInfo.tenantTitle}}</b-navbar-brand>
        </b-navbar-nav>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item to="/portal/" :active="path  == '/'"  v-b-tooltip.hover  :title="$t('nav.home')">
              <b-icon icon="house" aria-hidden="true" variant="white"></b-icon>
            </b-nav-item>
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-item>
              <LocaleSwitcher />
            </b-nav-item>
            <b-nav-item to="/portal/announcements" :active="path  == '/'"  v-b-tooltip.hover.topleft :title="$t('nav.announcements')" :disabled="hasNoAnnouncements()">
                <b-iconstack  v-if="hasNoAnnouncements()">
                  <b-icon stacked icon="exclamation" variant="white" ></b-icon>
                  <b-icon stacked icon="slash-circle" variant="secondary"></b-icon>
                </b-iconstack>
                <b-icon v-else  icon="patch-exclamation" aria-hidden="true" variant="white"></b-icon>
            </b-nav-item>
            <b-nav-item to="/portal/help" :active="path  == '/'" v-b-tooltip.hover.top :title="$t('nav.help')">
                <b-icon icon="question-circle" aria-hidden="true" variant="white"></b-icon>
            </b-nav-item>
            <b-nav-item-dropdown right v-b-tooltip.hover.topright :title="$t('nav.settings')">
              <template #button-content>
                <b-icon icon="gear" aria-hidden="true" variant="white"></b-icon>
              </template>
              <b-dropdown-item to="/portal/contact" :active="path  == '/'">{{ $t("nav.unitInfo")}}</b-dropdown-item>
              <b-dropdown-item to="/portal/property" :active="path  == '/'">{{ $t("nav.propertyInfo")}}</b-dropdown-item>
              <b-dropdown-item to="/portal/loggedOut" :active="path  == '/'">{{ $t("nav.signOut")}}</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
import store from "../store/store";
import LocaleSwitcher from "@/components/LocaleSwitcher"
export default {
  name:"NavBar",
  components: { LocaleSwitcher },
  async mounted () {
      await store.dispatch("loadPropertyInfo")
      await store.dispatch("loadPropertyConfigurationInfo")
      await store.dispatch("loadAnnouncements")
  },
  methods: {
    hasNoAnnouncements(){
      return !store.getters.isAnnouncementPresent;
    }
  }
}
</script>
